import { render } from "./RedeemAsync.vue?vue&type=template&id=cdc3bb5c&scoped=true"
import script from "./RedeemAsync.vue?vue&type=script&lang=js"
export * from "./RedeemAsync.vue?vue&type=script&lang=js"

import "./RedeemAsync.vue?vue&type=style&index=0&id=cdc3bb5c&lang=css&scoped=true"

import exportComponent from "/usr/src/app/vue-goparity/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdc3bb5c"]])

export default __exports__